<div class="container-xxl flex-grow-1 container-p-y">
    <div class="row mb-6 gy-6">
      <div class="col-xl">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center bg-light">
            <h4 class="mb-0">Notification</h4>
          </div>
  
          <div class="card-header pl-2">
            <h5 class="mb-0 fw-3">Send a new notification to a user</h5>
          </div>
  
          <div class="card-body border rounded-3 p-3">
            <form [formGroup]="entityForm" (ngSubmit)="onSubmit()">
  
            
              
              <div formGroupName="title">

                <div class="row mb-1">
                  <div class="col-12">
                    <div class="card shadow-sm border-0 mt-2">
                      <div class="card-body position-relative p-4">
                        <span
                          class="position-absolute bg-white px-3 text-goalngo font-weight-bold"
                          style="top: 0; left: 20px; transform: translateY(-50%); z-index: 1;"
                        >
                          Notification To
                        </span>
                
                        <div class="row align-items-center">
                          <div class="col-md-2 col-sm-3 text-center">
                            <img
                              [src]="getFirstImage(userInfo)"
                              alt="user-photo"
                              class="rounded-circle border border-secondary shadow-sm"
                              width="100"
                              height="100"
                            />
                          </div>
                
                          <div class="col-md-10 col-sm-9">
                            <h5 class="mb-1">{{ userInfo.firstName + ' ' + userInfo.lastName }}</h5>
                            <p class="mb-0 text-muted">{{userInfo.role}}</p>
                            <p class="mb-0 text-muted">{{userInfo.email}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
  
                <!-- Ttile in English -->
                <div class="mb-3">
                  <label class="form-label" for="fullName">Notification title <small
                      class="text-muted">(English)</small></label>
                  <input type="text" class="form-control" id="enTitle" formControlName="en"
                    [class.error]="entityForm.get('title.en').invalid && entityForm.get('title.en').touched"
                    placeholder="Notification Header(EN)" />
                  <span class="text-danger">
                    <span *ngIf="entityForm.get('title.en').invalid && entityForm.get('title.en').touched">
                      <span *ngIf="entityForm.get('title.en').errors?.['required']"><small>Title is
                          required.</small></span>
                      <span *ngIf="entityForm.get('title.en').errors?.['minlength']"><small>Title must be at least 3
                          characters.</small></span>
                    </span>
                  </span>
                </div>
  
                <!-- Ttile in Arabic -->
                <div class="mb-3">
                  <label class="form-label" for="fullName">Notification Title <small
                      class="text-muted">(Arabic)</small></label>
                  <input type="text" class="form-control" id="arTitle" formControlName="ar"
                    [class.error]="entityForm.get('title.ar').invalid && entityForm.get('title.ar').touched"
                    placeholder="Notification Header(AR)" />
                  <span>
                    <span *ngIf="entityForm.get('title.ar').invalid && entityForm.get('title.ar').touched">
                      <span *ngIf="entityForm.get('title.ar').errors?.['required']"><small>Title is
                          required.</small></span>
                      <span *ngIf="entityForm.get('title.ar').errors?.['minlength']"><small>Title must be at least 3
                          characters.</small></span>
                    </span>
                  </span>
                </div>
              </div>
  
  
              <!-- Notification Body in both english and arabic -->
              <div formGroupName="body">
                <div class="mb-3">
                  <label class="form-label" for="ENmessage">Notification Content <small>(English)</small></label>
                  <textarea class="form-control" id="ENmessage" formControlName="en" rows="2"
                    [class.error]="entityForm.get('body.en').invalid && entityForm.get('body.en').touched"
                    placeholder="Notification body (English)"></textarea>
                  <span class="text-danger">
                    <span *ngIf="entityForm.get('body.en').invalid && entityForm.get('body.en').touched">
                      <span *ngIf="entityForm.get('body.en').errors?.['required']"><small>Information is
                          required.</small></span>
                    </span>
                  </span>
                </div>
  
                <div class="mb-3">
                  <label class="form-label" for="ARmessage">Notification Content <small
                      class="text-muted">(Arabic)</small></label>
                  <textarea class="form-control" id="ARmessage" formControlName="ar" rows="2"
                    [class.error]="entityForm.get('body.ar').invalid && entityForm.get('body.ar').touched"
                    placeholder="Notification body (Arabic)"></textarea>
                  <span class="text-danger">
                    <span *ngIf="entityForm.get('body.ar').invalid && entityForm.get('body.ar').touched">
                      <span *ngIf="entityForm.get('body.ar').errors?.['required']"><small>Information is
                          required.</small></span>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <button type="submit" class="btn btnn">SEND NOTIFICATION <i class="bi bi-bell-fill"></i></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>